var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.748 78.254 c -0.178 0 -0.356 -0.048 -0.514 -0.143 c -0.301 -0.181 -0.486 -0.506 -0.486 -0.857 V 12.746 c 0 -0.352 0.185 -0.677 0.486 -0.858 c 0.303 -0.181 0.676 -0.19 0.985 -0.024 l 20.115 10.751 c 0.326 0.174 0.529 0.513 0.529 0.882 s -0.203 0.708 -0.529 0.882 l -18.464 9.87 l 18.464 9.87 c 0.326 0.174 0.529 0.513 0.529 0.882 s -0.203 0.708 -0.529 0.882 L 7.869 55.751 l 18.464 9.87 c 0.326 0.174 0.529 0.513 0.529 0.882 s -0.203 0.708 -0.529 0.882 L 6.219 78.136 C 6.071 78.215 5.909 78.254 5.748 78.254 z M 6.748 57.419 v 18.167 l 16.993 -9.083 L 6.748 57.419 z M 6.748 35.917 v 18.166 L 23.741 45 L 6.748 35.917 z M 6.748 14.414 V 32.58 l 16.993 -9.083 L 6.748 14.414 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.866 67.503 H 25.862 c -0.552 0 -1 -0.447 -1 -1 V 23.497 c 0 -0.552 0.448 -1 1 -1 h 16.004 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 H 26.862 v 41.006 h 15.004 c 0.552 0 1 0.447 1 1 S 42.418 67.503 41.866 67.503 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.866 46 H 25.862 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 16.004 c 0.552 0 1 0.448 1 1 S 42.418 46 41.866 46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.87,
    y: 16.1,
    rx: 0,
    ry: 0,
    width: 8.78,
    height: 57.8,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(201,207,212)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.65 74.897 h -8.784 c -0.552 0 -1 -0.447 -1 -1 V 16.103 c 0 -0.552 0.448 -1 1 -1 h 8.784 c 0.553 0 1 0.448 1 1 v 57.795 C 51.65 74.45 51.203 74.897 50.65 74.897 z M 42.866 72.897 h 6.784 V 17.103 h -6.784 V 72.897 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.747,
    cy: 12.747,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,191,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.748 18.493 C 2.578 18.493 0 15.915 0 12.746 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 11.495 15.915 8.917 18.493 5.748 18.493 z M 5.748 8.999 C 3.681 8.999 2 10.68 2 12.746 c 0 2.066 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.681 3.747 -3.748 C 9.495 10.68 7.813 8.999 5.748 8.999 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.747,
    cy: 34.247,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(241,123,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.748 39.996 C 2.578 39.996 0 37.418 0 34.249 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 11.495 37.418 8.917 39.996 5.748 39.996 z M 5.748 30.501 C 3.681 30.501 2 32.183 2 34.249 c 0 2.066 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.681 3.747 -3.748 C 9.495 32.183 7.813 30.501 5.748 30.501 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.747,
    cy: 55.747,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,191,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.748 61.499 C 2.578 61.499 0 58.921 0 55.751 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 11.495 58.921 8.917 61.499 5.748 61.499 z M 5.748 52.004 C 3.681 52.004 2 53.685 2 55.751 s 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.682 3.747 -3.748 S 7.813 52.004 5.748 52.004 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.747,
    cy: 77.257,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(126,198,197)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.748 83.002 C 2.578 83.002 0 80.424 0 77.254 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 11.495 80.424 8.917 83.002 5.748 83.002 z M 5.748 73.507 C 3.681 73.507 2 75.188 2 77.254 s 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.682 3.747 -3.748 S 7.813 73.507 5.748 73.507 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.857,
    cy: 23.497,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,191,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.862 29.245 c -3.169 0 -5.748 -2.578 -5.748 -5.748 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 31.609 26.667 29.031 29.245 25.862 29.245 z M 25.862 19.75 c -2.066 0 -3.748 1.681 -3.748 3.747 c 0 2.066 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.681 3.747 -3.748 C 29.609 21.431 27.928 19.75 25.862 19.75 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.857,
    cy: 44.997,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(126,198,197)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.862 50.747 c -3.169 0 -5.748 -2.578 -5.748 -5.747 c 0 -3.169 2.578 -5.748 5.748 -5.748 c 3.169 0 5.747 2.578 5.747 5.748 C 31.609 48.169 29.031 50.747 25.862 50.747 z M 25.862 41.252 c -2.066 0 -3.748 1.681 -3.748 3.748 s 1.681 3.747 3.748 3.747 c 2.066 0 3.747 -1.681 3.747 -3.747 S 27.928 41.252 25.862 41.252 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.857,
    cy: 66.507,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(241,123,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.862 72.25 c -3.169 0 -5.748 -2.578 -5.748 -5.747 s 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 S 29.031 72.25 25.862 72.25 z M 25.862 62.756 c -2.066 0 -3.748 1.681 -3.748 3.747 s 1.681 3.747 3.748 3.747 c 2.066 0 3.747 -1.681 3.747 -3.747 S 27.928 62.756 25.862 62.756 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.862 29.245 c -3.169 0 -5.748 -2.578 -5.748 -5.748 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 31.609 26.667 29.031 29.245 25.862 29.245 z M 25.862 19.75 c -2.066 0 -3.748 1.681 -3.748 3.747 c 0 2.066 1.681 3.748 3.748 3.748 c 2.066 0 3.747 -1.681 3.747 -3.748 C 29.609 21.431 27.928 19.75 25.862 19.75 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.185 24.497 c -0.278 0 -0.555 -0.116 -0.753 -0.342 c -0.363 -0.416 -0.321 -1.047 0.095 -1.411 l 12.292 -10.751 c 0.182 -0.159 0.416 -0.247 0.658 -0.247 h 8.052 c 0.553 0 1 0.448 1 1 s -0.447 1 -1 1 h -7.676 L 62.843 24.25 C 62.653 24.416 62.419 24.497 62.185 24.497 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.528 78.254 h -8.052 c -0.242 0 -0.477 -0.088 -0.658 -0.247 L 61.526 67.256 c -0.416 -0.364 -0.458 -0.995 -0.095 -1.411 c 0.365 -0.418 0.996 -0.458 1.411 -0.095 l 12.01 10.504 h 7.676 c 0.553 0 1 0.447 1 1 S 83.081 78.254 82.528 78.254 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.185 67.503 H 50.65 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 11.534 c 0.553 0 1 0.447 1 1 S 62.737 67.503 62.185 67.503 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.185 24.497 H 50.65 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 11.534 c 0.553 0 1 0.448 1 1 S 62.737 24.497 62.185 24.497 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.257,
    cy: 12.747,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,191,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.253 18.493 c -3.17 0 -5.748 -2.578 -5.748 -5.748 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 90 15.915 87.422 18.493 84.253 18.493 z M 84.253 8.999 c -2.066 0 -3.748 1.681 -3.748 3.747 c 0 2.066 1.682 3.748 3.748 3.748 S 88 14.812 88 12.746 C 88 10.68 86.319 8.999 84.253 8.999 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.257,
    cy: 77.257,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(126,198,197)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.253 83.002 c -3.17 0 -5.748 -2.578 -5.748 -5.748 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 90 80.424 87.422 83.002 84.253 83.002 z M 84.253 73.507 c -2.066 0 -3.748 1.681 -3.748 3.747 s 1.682 3.748 3.748 3.748 S 88 79.32 88 77.254 S 86.319 73.507 84.253 73.507 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.528 61.971 h -8.052 c -0.161 0 -0.319 -0.039 -0.462 -0.113 l -12.292 -6.399 c -0.489 -0.255 -0.68 -0.858 -0.425 -1.349 c 0.254 -0.489 0.857 -0.683 1.349 -0.425 l 12.075 6.286 h 7.807 c 0.553 0 1 0.447 1 1 S 83.081 61.971 82.528 61.971 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.185 55.571 H 50.65 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 11.534 c 0.553 0 1 0.447 1 1 S 62.737 55.571 62.185 55.571 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.257,
    cy: 60.967,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(241,123,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.253 66.718 c -3.17 0 -5.748 -2.578 -5.748 -5.747 s 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 S 87.422 66.718 84.253 66.718 z M 84.253 57.224 c -2.066 0 -3.748 1.681 -3.748 3.747 s 1.682 3.747 3.748 3.747 S 88 63.037 88 60.971 S 86.319 57.224 84.253 57.224 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.186 36.428 c -0.361 0 -0.71 -0.196 -0.888 -0.538 c -0.255 -0.49 -0.064 -1.094 0.425 -1.349 l 12.292 -6.399 c 0.143 -0.074 0.301 -0.113 0.462 -0.113 h 8.052 c 0.553 0 1 0.448 1 1 s -0.447 1 -1 1 h -7.807 l -12.075 6.286 C 62.499 36.392 62.341 36.428 62.186 36.428 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62.185 36.428 H 50.65 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 11.534 c 0.553 0 1 0.448 1 1 S 62.737 36.428 62.185 36.428 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.257,
    cy: 29.027,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(241,123,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.253 34.777 c -3.17 0 -5.748 -2.578 -5.748 -5.748 c 0 -3.169 2.578 -5.747 5.748 -5.747 c 3.169 0 5.747 2.578 5.747 5.747 C 90 32.199 87.422 34.777 84.253 34.777 z M 84.253 25.282 c -2.066 0 -3.748 1.681 -3.748 3.747 c 0 2.066 1.682 3.748 3.748 3.748 S 88 31.096 88 29.029 C 88 26.963 86.319 25.282 84.253 25.282 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79.505 46 H 50.65 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 28.854 c 0.553 0 1 0.448 1 1 S 80.058 46 79.505 46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.257,
    cy: 44.997,
    r: 4.747,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,191,80)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.253 50.747 c -3.17 0 -5.748 -2.578 -5.748 -5.747 c 0 -3.169 2.578 -5.748 5.748 -5.748 C 87.422 39.252 90 41.831 90 45 C 90 48.169 87.422 50.747 84.253 50.747 z M 84.253 41.252 c -2.066 0 -3.748 1.681 -3.748 3.748 s 1.682 3.747 3.748 3.747 S 88 47.066 88 45 S 86.319 41.252 84.253 41.252 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.801 36.963 c -0.552 0 -1 -0.448 -1 -1 v -5.927 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 5.927 C 37.801 36.516 37.353 36.963 36.801 36.963 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36.801 60.964 c -0.552 0 -1 -0.447 -1 -1 v -5.928 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 5.928 C 37.801 60.517 37.353 60.964 36.801 60.964 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/ml.51aa4d5ad6f33cbec18b96a63db7b33e.svg";
export { ForwardRef as ReactComponent };